module.exports = __webpack_public_path__ + "static/cocof-c6a0ee42e2e9fbc7644101ea0843922d.png";